const _ = "_scroll_117fk_1", s = {
  "usp-bar": "_usp-bar_117fk_9",
  "usp-bar__track": "_usp-bar__track_117fk_19",
  scroll: _,
  "usp-bar__item": "_usp-bar__item_117fk_31"
};
export {
  s as default,
  _ as scroll
};
